module.exports = __webpack_public_path__ + "images/uwlogo343d3bd57c3893df0443220881fcf5d9.png";